export const POPUP_ACT_SHOW = 'POPUP_ACT_SHOW';
export const POPUP_ACT_CLOSE = 'POPUP_ACT_CLOSE';

export const DOP_POPUP_SHOW = 'DOP_POPUP_SHOW';
export const DOP_POPUP_CLOSE = 'DOP_POPUP_CLOSE';

export const POPUP_ACT_REPORT = 'POPUP_ACT_REPORT';
export const POPUP_ACT_REPORT_SUCCESS = 'POPUP_ACT_REPORT_SUCCESS';
export const POPUP_ACT_REPORT_FAIL = 'POPUP_ACT_REPORT_FAIL';

export const POPUP_ACT_ERROR_CLOSE = 'POPUP_ACT_ERROR_CLOSE';

// Добавление особых отметок
export const POPUP_ACT_ADD_NOTE = 'POPUP_ACT_ADD_NOTE';
export const POPUP_ACT_ADD_NOTE_SUCCESS = 'POPUP_ACT_ADD_NOTE_SUCCESS';
export const POPUP_ACT_ADD_NOTE_FAIL = 'POPUP_ACT_ADD_NOTE_FAIL';

// Получение особых отметок
export const POPUP_ACT_GET_NOTE = 'POPUP_ACT_GET_NOTE';
export const POPUP_ACT_GET_NOTE_SUCCESS = 'POPUP_ACT_GET_NOTE_SUCCESS';
export const POPUP_ACT_GET_NOTE_FAIL = 'POPUP_ACT_GET_NOTE_FAIL';

export const POPUP_HOLDER_REPORT_SHOW = 'POPUP_HOLDER_REPORT_SHOW';
export const POPUP_HOLDER_REPORT_CLOSE = 'POPUP_HOLDER_REPORT_CLOSE';

export const SET_NEW_FORMED = 'SET_NEW_FORMED';
